<ng-container
    *ngrxLet="{
        isSearchProcessing: isSearchProcessing$,
        searchResults: searchResults$,
        highlightedResultIndex: highlightedResultIndex$,
        selectedResults: selectedResults$,
    } as vm"
>
    <dtm-ui-input-field [isClearable]="false">
        <dtm-ui-icon class="input-prefix" name="search" *ngIf="!vm.isSearchProcessing" @fade></dtm-ui-icon>
        <dtm-ui-icon class="input-prefix loader-icon" name="loader" *ngIf="vm.isSearchProcessing" @fade></dtm-ui-icon>
        <input
            matInput
            [formControl]="searchQueryFormControl"
            [placeholder]="(placeholderText$ | ngrxPush) ?? 'dtmMapSearchLib.poiSearch.searchPlaceholder' | transloco"
            type="text"
            autocomplete="off"
            #searchInput
            (keydown)="onInputKeyDown($event)"
            (focus)="focus($event)"
            class="search-input"
            [class.empty]="!searchInput.value || !vm.selectedResults"
        />
        <div class="preview" *ngIf="vm.selectedResults">
            <p [innerHTML]="vm.selectedResults.name"></p>
        </div>
        <button class="input-suffix button-link clear-button" (click)="clearSearch()" type="button" *ngIf="searchQueryFormControl.value">
            {{ "dtmMapSearchLib.poiSearch.clearButtonLabel" | transloco }}
        </button>
    </dtm-ui-input-field>
    <div class="results-container scroll-shadows" *ngIf="vm.searchResults" role="listbox">
        <div class="empty-results" *ngIf="vm.searchResults.length === 0">
            {{ "dtmMapSearchLib.poiSearch.noResultsMessage" | transloco }}
        </div>
        <div
            class="result-item"
            #resultItem
            *ngFor="let result of vm.searchResults; let index = index"
            (click)="selectResult(result)"
            (mouseenter)="setHighlightedResultIndex(index)"
            [class.active]="vm.highlightedResultIndex === index"
            [attr.aria-selected]="vm.highlightedResultIndex === index"
            role="option"
        >
            <dtm-ui-icon [name]="result.type === 'PIN' ? 'map-pin' : 'cylinder-line'" class="result-item-icon"></dtm-ui-icon>
            <div class="result-item-title" [innerHTML]="result.highlightedName"></div>
        </div>
    </div>
</ng-container>
